import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";

export const useCarMakesOptions = () => useTypedQuery({ queryKey: AppointmentsQueryKeys.carMakesOptions, initialData: [] }).data;
export const setCarMakesOptions = (carMakes: string[]) => typedQueryClient.setQueryData(AppointmentsQueryKeys.carMakesOptions, carMakes);
